import { SxProps } from '@mui/material';

export const styledEditionalText: SxProps = {
  opacity: '40%',
};
